<template>
  <div id="user-management">
    <div class="panel__header">
      <div class="invite-btn-box">
        <button type="button" class="qrcode_handle_btn" @click="dialogVisibleUserBind = true">
          关联用户
        </button>
        <button
          type="button"
          class="qrcode_handle_btn"
          style="margin-left: 20px"
          @click="openInviteUser"
        >
          邀请用户
        </button>
      </div>
      <div class="user-search-inp-box">
        <div class="qrcode_input" style="width: 200px">
          <el-input
            v-model.trim="condition"
            placeholder="搜索用戶"
            @keyup.enter.native="conditionSearch"
          ></el-input>
        </div>

        <span class="search-btn-box" @click="conditionSearch"
          ><i class="el-icon-search icon-style"></i
        ></span>
      </div>
    </div>
    <div class="panel__body">
      <el-table ref="tableData" v-loading="loading" :data="tableData" height="calc(100vh - 210px)">
        <el-table-column prop="" label="" width="55">
          <template slot-scope="scope">
            <img
              v-if="scope.row.UserHeadImgUrl == null"
              src="../../assets/images/icon/icon_header_avatar-default.svg"
              style="width: 30px; height: 30px"
              alt="头像"
            />
            <img
              v-else
              :src="scope.row.UserHeadImgUrl"
              style="width: 30px; height: 30px"
              alt="头像"
            />
          </template>
        </el-table-column>
        <el-table-column prop="UserName" label="姓名" width=""></el-table-column>
        <el-table-column prop="MobilePhone" label="手机" width=""></el-table-column>
        <el-table-column prop="UserEmail" label="邮箱" width=""></el-table-column>
        <el-table-column prop="RoleName" label="角色" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.State == 'view'">{{ scope.row.RoleName }}</span>
            <el-select
              v-else
              v-model="role"
              multiple
              collapse-tags
              placeholder="请选择"
              class="qrcode_input"
            >
              <el-option
                v-for="item in roleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column prop="" label="" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.State == 'view'" class="inline-block">
              <img
                alt="编辑"
                class="opinion-tab-btn iconfont-table-operate"
                src="../../assets/images/icon/icon_table_modify.png"
                title="编辑"
                @click="modifyProjectUser(scope.row, scope)"
              />
            </div>
            <div v-if="scope.row.State == 'view'" class="inline-block">
              <img
                alt="删除"
                class="opinion-tab-btn iconfont-table-operate"
                style="margin-left: 12px"
                src="../../assets/images/icon/icon_table_delete.png"
                title="删除"
                @click="removeProjectUser(scope.row.ID)"
              />
            </div>
            <div v-if="scope.row.State == 'edit'" class="inline-block">
              <i class="el-icon-check tab_opinion_icon" title="保存" @click="updateProjectUser"></i>
            </div>
            <div v-if="scope.row.State == 'edit'" class="inline-block" style="margin-left: 12px">
              <i class="el-icon-close tab_opinion_icon" title="取消" @click="cancelUser"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container flex flex-row items-center justify-end">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          background
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <div>
      <UserBind
        :user-bind-prop="dialogVisibleUserBind"
        @close-user-binding-modal="closeUserBindModal"
      ></UserBind>
    </div>

    <div>
      <InviteUser
        ref="invite"
        :invite-user-prop="dialogVisibleInviteUser"
        :link-prop="link"
        @close-invite-user-modal="closeInviteUserModal"
      ></InviteUser>
    </div>
  </div>
</template>
<script>
// let _this = void 0
import UserBind from '@/components/user-management/UserBind.vue'
import InviteUser from '@/components/user-management/InviteUser.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'UserManagement',
  components: {
    UserBind,
    InviteUser,
  },
  filters: {},
  directives: {},
  mixins: [],
  props: {},
  data() {
    return {
      condition: '',
      tableData: [],
      loading: false,
      currentPage: 0,
      pageSize: 10,
      total: 0,
      dialogVisibleUserBind: false,
      dialogVisibleInviteUser: false,
      link: '',
      roleOptions: [],
      role: null,
      // 选中用户的ID
      userID: null,
      wxURL: '', // 微信Url
    }
  },
  computed: {
    // ...mapState('', {}),
  },
  watch: {},
  created() {
    // _this = this
  },
  mounted() {
    this.refreshTable()
    this.getProjectRoles()
  },
  destroy() {},
  methods: {
    ...mapGetters({
      getProjectId: 'getProjectId',
    }),
    /*
     * 根据项目ID,获取项目上用户列表
     * */
    async getProjectUserData() {
      this.loading = true
      const { success, data } = await this.$http({
        url: this.$api.getProjectUserPageList,
        params: {
          keyword: this.condition,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        },
      })
      if (success) {
        const { rows, total } = data
        for (const item of rows) {
          item.State = 'view'
        }
        this.total = total
        this.tableData = [...rows]
        this.loading = false
      } else {
        this.$message({
          type: 'error',
          message: '获取用户数据失败！',
        })
      }
    },
    /*
     * 刷新表格，用户初始化
     * */
    refreshTable() {
      this.currentPage = 0
      this.pageSize = 10
      this.getProjectUserData()
    },
    /*
     * 每页数数据获取变更触发
     * @parma pageSize {number} 一次返回多少条数据
     * */
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getProjectUserData()
    },
    /*
     * 页码变更触发
     * @parma pageNumber {number} 页码数，返回需要-1处理
     * */
    handleCurrentChange(pageNumber) {
      this.currentPage = pageNumber - 1
      this.getProjectUserData()
    },
    /*
     * 点击搜索按钮，添加查询
     * */
    conditionSearch() {
      this.refreshTable()
    },
    /*
     * 关联用户modal框关闭
     * */
    closeUserBindModal() {
      this.dialogVisibleUserBind = false
    },
    // 点击邀请用户按钮,获取邀请链接数据
    async openInviteUser() {
      this.dialogVisibleInviteUser = true
      this.$refs.invite.openInviteUser()
    },
    /*
     * 邀请用户modal框关闭
     * */
    closeInviteUserModal() {
      this.dialogVisibleInviteUser = false
    },
    /*
     * 点击移除按钮弹出框
     * @parma id {number} 用户ID
     * */
    async removeProjectUser(id) {
      this.$confirm('确定移除当前用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'qrcode_modal_confirm_btn',
        cancelButtonClass: 'qrcode_modal_cancel_btn',
      }).then(async () => {
        await this.commitRemoveProjectUser(id)
      })
    },
    /*
     * 提交删除用户接口
     * @param userID {number} 要删除用户的ID
     * */
    async commitRemoveProjectUser(userID) {
      const { success } = await this.$http({
        url: this.$api.deleteProjectUser,
        param: {
          userID,
        },
      })
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '删除成功！' : '删除失败！',
      })
    },
    /*
     *编辑编辑按钮触发事件
     * @param row {object} 选中的用户信息
     * */
    modifyProjectUser(row, item) {
      this.cancelUser()
      const selectIndex = item.$index
      this.role = row.RoleID.split(',').map(Number)
      this.userID = row.ID
      this.tableData[selectIndex].State = 'edit'
    },
    /*
     * 获取角色数据
     * */
    async getProjectRoles() {
      const { success, data } = await this.$http({
        url: this.$api.getProjectRoles,
      })
      if (success) {
        for (const item of data) {
          const option = { label: item.Name, value: item.ID }
          this.roleOptions.push(option)
        }
      } else {
        this.$message({
          type: 'error',
          message: '获取用户角色失败！',
        })
      }
    },
    /*
     * 取消用户角色操作
     * */
    cancelUser() {
      this.userID = null
      this.role = null
      for (const index in this.tableData) {
        if (this.tableData[index].State === 'add') {
          this.tableData.splice(index, 1)
        } else {
          this.tableData[index].State = 'view'
        }
      }
    },
    /*
     * 提交更新角色接口
     * */
    async updateProjectUser() {
      const userRoleItemList = []
      for (const item of this.role) {
        const value = { ID: item }
        userRoleItemList.push(value)
      }
      const { success } = await this.$http({
        url: this.$api.updateProjectUser,
        method: 'post',
        data: {
          UserId: this.userID,
          UserRoleItemList: userRoleItemList,
        },
      })
      if (success) {
        this.refreshTable()
      }
      this.$message({
        type: success ? 'success' : 'error！',
        message: success ? '用户角色更新成功！' : '用户角色更新失败！',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
#user-management {
  width: 100%;
  overflow: auto;
  border-radius: 4px;
  background-color: #ffffff;
}
.head-wrapper {
  display: flex;
  height: 60px;
  flex-wrap: nowrap;
  padding: 0 15px;
  border-bottom: 1px solid #f0f0f0;
  align-items: center;
}

.invite-btn-box {
  flex: 1;
}
.user-search-inp-box {
  flex: 2;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

.icon-style {
  font-size: 22px;
  color: #ffffff;
}
.iconfont-table-operate {
  display: none !important;
  color: #409eff;
  font-size: 18px;
  cursor: pointer;
}
.el-table__row:hover .iconfont-table-operate {
  display: inline-block !important;
}
.opinion-tab-btn {
  width: 22px;
  height: 22px;
}
.tab_opinion_icon {
  font-size: 22px;
  color: #409eff;
  cursor: pointer;
}
.inline-block {
  display: inline-block;
}
#user-management ::v-deep .el-input__icon {
  line-height: 32px;
}
</style>
